@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-958_594_753)
public val Res.string.job_cv_max_size: StringResource by lazy {
      StringResource("string:job_cv_max_size", "job_cv_max_size", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 157737, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 223061, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143276, 51),
      ))
    }

@delegate:ResourceContentHash(621_735_615)
public val Res.string.job_cv_none: StringResource by lazy {
      StringResource("string:job_cv_none", "job_cv_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 157797, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 223141, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143328, 39),
      ))
    }

@delegate:ResourceContentHash(-1_141_996_053)
public val Res.string.job_cv_optional: StringResource by lazy {
      StringResource("string:job_cv_optional", "job_cv_optional", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 157825, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 223173, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143368, 35),
      ))
    }

@delegate:ResourceContentHash(-1_848_214_819)
public val Res.string.job_cv_required: StringResource by lazy {
      StringResource("string:job_cv_required", "job_cv_required", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 157869, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 223233, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143404, 35),
      ))
    }

@delegate:ResourceContentHash(826_162_795)
public val Res.string.job_cv_types: StringResource by lazy {
      StringResource("string:job_cv_types", "job_cv_types", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 157905, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 223289, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143440, 36),
      ))
    }

@delegate:ResourceContentHash(-1_100_734_385)
public val Res.string.job_delete: StringResource by lazy {
      StringResource("string:job_delete", "job_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 158231, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 223815, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143750, 38),
      ))
    }

@delegate:ResourceContentHash(-1_952_330_898)
public val Res.string.job_delete_confirm_text: StringResource by lazy {
      StringResource("string:job_delete_confirm_text", "job_delete_confirm_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 157946, 171),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 223338, 327),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143477, 167),
      ))
    }

@delegate:ResourceContentHash(419_901_134)
public val Res.string.job_delete_confirm_title: StringResource by lazy {
      StringResource("string:job_delete_confirm_title", "job_delete_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 158118, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 223666, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143645, 60),
      ))
    }

@delegate:ResourceContentHash(1_258_571_188)
public val Res.string.job_deleted: StringResource by lazy {
      StringResource("string:job_deleted", "job_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 158183, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 223751, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143706, 43),
      ))
    }

@delegate:ResourceContentHash(784_450_734)
public val Res.string.job_editor_new_title: StringResource by lazy {
      StringResource("string:job_editor_new_title", "job_editor_new_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 158274, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 223878, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143789, 44),
      ))
    }

@delegate:ResourceContentHash(1_332_372_709)
public val Res.string.job_editor_title: StringResource by lazy {
      StringResource("string:job_editor_title", "job_editor_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 158327, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 223943, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143834, 36),
      ))
    }

@delegate:ResourceContentHash(-1_285_309_217)
public val Res.string.job_error_contact: StringResource by lazy {
      StringResource("string:job_error_contact", "job_error_contact", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 158380, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 223992, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143871, 81),
      ))
    }

@delegate:ResourceContentHash(1_596_328_575)
public val Res.string.job_error_cv_types: StringResource by lazy {
      StringResource("string:job_error_cv_types", "job_error_cv_types", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 158462, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 224106, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143953, 66),
      ))
    }

@delegate:ResourceContentHash(1_852_687_316)
public val Res.string.job_error_employer: StringResource by lazy {
      StringResource("string:job_error_employer", "job_error_employer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 158541, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 224213, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144020, 62),
      ))
    }

@delegate:ResourceContentHash(2_006_185_703)
public val Res.string.job_error_pay: StringResource by lazy {
      StringResource("string:job_error_pay", "job_error_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 158688, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 224428, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144179, 61),
      ))
    }

@delegate:ResourceContentHash(1_459_110_010)
public val Res.string.job_error_pay_range: StringResource by lazy {
      StringResource("string:job_error_pay_range", "job_error_pay_range", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 158600, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 224300, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144083, 95),
      ))
    }

@delegate:ResourceContentHash(-1_453_088_926)
public val Res.string.job_error_title: StringResource by lazy {
      StringResource("string:job_error_title", "job_error_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 158758, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 224518, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144241, 51),
      ))
    }

@delegate:ResourceContentHash(-1_037_743_332)
public val Res.string.job_error_too_long: StringResource by lazy {
      StringResource("string:job_error_too_long", "job_error_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 158814, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 224590, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144293, 66),
      ))
    }

@delegate:ResourceContentHash(1_773_175_465)
public val Res.string.job_field_city: StringResource by lazy {
      StringResource("string:job_field_city", "job_field_city", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 158881, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 224669, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144360, 42),
      ))
    }

@delegate:ResourceContentHash(-484_467_236)
public val Res.string.job_field_closes: StringResource by lazy {
      StringResource("string:job_field_closes", "job_field_closes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 158924, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 224724, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144403, 64),
      ))
    }

@delegate:ResourceContentHash(2_017_224_372)
public val Res.string.job_field_contact: StringResource by lazy {
      StringResource("string:job_field_contact", "job_field_contact", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 159128, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 225032, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144595, 69),
      ))
    }

@delegate:ResourceContentHash(-1_521_856_833)
public val Res.string.job_field_contact_hint: StringResource by lazy {
      StringResource("string:job_field_contact_hint", "job_field_contact_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 158993, 134),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 224813, 218),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144468, 126),
      ))
    }

@delegate:ResourceContentHash(824_235_721)
public val Res.string.job_field_contract: StringResource by lazy {
      StringResource("string:job_field_contract", "job_field_contract", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 159202, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 225130, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144665, 38),
      ))
    }

@delegate:ResourceContentHash(1_560_121_357)
public val Res.string.job_field_description: StringResource by lazy {
      StringResource("string:job_field_description", "job_field_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 159245, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 225177, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144704, 45),
      ))
    }

@delegate:ResourceContentHash(-451_283_138)
public val Res.string.job_field_employer: StringResource by lazy {
      StringResource("string:job_field_employer", "job_field_employer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 159403, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 225411, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144886, 66),
      ))
    }

@delegate:ResourceContentHash(-77_854_479)
public val Res.string.job_field_employer_hint: StringResource by lazy {
      StringResource("string:job_field_employer_hint", "job_field_employer_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 159283, 119),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 225219, 191),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144750, 135),
      ))
    }

@delegate:ResourceContentHash(1_598_783_071)
public val Res.string.job_field_hours: StringResource by lazy {
      StringResource("string:job_field_hours", "job_field_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 159575, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 225643, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145042, 31),
      ))
    }

@delegate:ResourceContentHash(-2_020_830_692)
public val Res.string.job_field_hours_hint: StringResource by lazy {
      StringResource("string:job_field_hours_hint", "job_field_hours_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 159482, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 225518, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144953, 88),
      ))
    }

@delegate:ResourceContentHash(379_686_923)
public val Res.string.job_field_language: StringResource by lazy {
      StringResource("string:job_field_language", "job_field_language", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 159619, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 225683, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145074, 46),
      ))
    }

@delegate:ResourceContentHash(-1_506_868_826)
public val Res.string.job_field_pay_max: StringResource by lazy {
      StringResource("string:job_field_pay_max", "job_field_pay_max", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 159666, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 225746, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145121, 49),
      ))
    }

@delegate:ResourceContentHash(1_597_272_913)
public val Res.string.job_field_pay_min: StringResource by lazy {
      StringResource("string:job_field_pay_min", "job_field_pay_min", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 159728, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 225816, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145171, 49),
      ))
    }

@delegate:ResourceContentHash(1_969_510_733)
public val Res.string.job_field_role: StringResource by lazy {
      StringResource("string:job_field_role", "job_field_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 159790, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 225890, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145221, 46),
      ))
    }

@delegate:ResourceContentHash(800_303_933)
public val Res.string.job_field_title: StringResource by lazy {
      StringResource("string:job_field_title", "job_field_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 159982, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 226214, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145413, 35),
      ))
    }

@delegate:ResourceContentHash(-906_668_745)
public val Res.string.job_field_title_hint: StringResource by lazy {
      StringResource("string:job_field_title_hint", "job_field_title_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 159841, 140),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 225953, 260),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145268, 144),
      ))
    }

@delegate:ResourceContentHash(687_023_470)
public val Res.string.job_lang_en: StringResource by lazy {
      StringResource("string:job_lang_en", "job_lang_en", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 160030, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 226270, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145449, 31),
      ))
    }

@delegate:ResourceContentHash(949_387_616)
public val Res.string.job_lang_pl: StringResource by lazy {
      StringResource("string:job_lang_pl", "job_lang_pl", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 160062, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 226318, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145481, 27),
      ))
    }

@delegate:ResourceContentHash(143_933_982)
public val Res.string.job_lang_uk: StringResource by lazy {
      StringResource("string:job_lang_uk", "job_lang_uk", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 160090, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 226362, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145509, 31),
      ))
    }

@delegate:ResourceContentHash(83_985_471)
public val Res.string.job_pay_hint: StringResource by lazy {
      StringResource("string:job_pay_hint", "job_pay_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 160126, 168),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 226410, 256),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145541, 140),
      ))
    }

@delegate:ResourceContentHash(-209_016_369)
public val Res.string.job_pay_per_hour: StringResource by lazy {
      StringResource("string:job_pay_per_hour", "job_pay_per_hour", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 160295, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 226667, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145682, 36),
      ))
    }

@delegate:ResourceContentHash(-2_022_644_660)
public val Res.string.job_pay_per_month: StringResource by lazy {
      StringResource("string:job_pay_per_month", "job_pay_per_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 160336, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 226716, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145719, 37),
      ))
    }

@delegate:ResourceContentHash(-423_918_841)
public val Res.string.job_publish: StringResource by lazy {
      StringResource("string:job_publish", "job_publish", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 160432, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 226844, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145803, 31),
      ))
    }

@delegate:ResourceContentHash(-194_797_612)
public val Res.string.job_published: StringResource by lazy {
      StringResource("string:job_published", "job_published", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 160378, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 226766, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145757, 45),
      ))
    }

@delegate:ResourceContentHash(-453_023_718)
public val Res.string.job_recruiters_empty: StringResource by lazy {
      StringResource("string:job_recruiters_empty", "job_recruiters_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 160464, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 226896, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145835, 60),
      ))
    }

@delegate:ResourceContentHash(1_869_331_513)
public val Res.string.job_recruiters_hint: StringResource by lazy {
      StringResource("string:job_recruiters_hint", "job_recruiters_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 160537, 299),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 226989, 479),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145896, 243),
      ))
    }

@delegate:ResourceContentHash(-275_031_958)
public val Res.string.job_rejection_body: StringResource by lazy {
      StringResource("string:job_rejection_body", "job_rejection_body", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 160837, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 227469, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146140, 34),
      ))
    }

@delegate:ResourceContentHash(-620_347_628)
public val Res.string.job_rejection_enabled: StringResource by lazy {
      StringResource("string:job_rejection_enabled", "job_rejection_enabled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 160876, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 227512, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146175, 73),
      ))
    }

@delegate:ResourceContentHash(-476_153_906)
public val Res.string.job_rejection_hint: StringResource by lazy {
      StringResource("string:job_rejection_hint", "job_rejection_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 160962, 186),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 227630, 270),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146249, 174),
      ))
    }

@delegate:ResourceContentHash(-1_271_776_885)
public val Res.string.job_rejection_subject: StringResource by lazy {
      StringResource("string:job_rejection_subject", "job_rejection_subject", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161149, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 227901, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146424, 41),
      ))
    }

@delegate:ResourceContentHash(1_089_999_153)
public val Res.string.job_reopen: StringResource by lazy {
      StringResource("string:job_reopen", "job_reopen", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161187, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 227943, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146466, 34),
      ))
    }

@delegate:ResourceContentHash(1_716_406_311)
public val Res.string.job_save_draft: StringResource by lazy {
      StringResource("string:job_save_draft", "job_save_draft", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161230, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 227998, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146501, 38),
      ))
    }

@delegate:ResourceContentHash(1_809_245_592)
public val Res.string.job_saved: StringResource by lazy {
      StringResource("string:job_saved", "job_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161285, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 228065, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146540, 37),
      ))
    }

@delegate:ResourceContentHash(-1_849_228_156)
public val Res.string.job_section_cv: StringResource by lazy {
      StringResource("string:job_section_cv", "job_section_cv", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161331, 26),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 228131, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146578, 26),
      ))
    }

@delegate:ResourceContentHash(642_530_051)
public val Res.string.job_section_recruiters: StringResource by lazy {
      StringResource("string:job_section_recruiters", "job_section_recruiters", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161358, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 228158, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146605, 46),
      ))
    }

@delegate:ResourceContentHash(11_197_726)
public val Res.string.job_section_rejection: StringResource by lazy {
      StringResource("string:job_section_rejection", "job_section_rejection", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161413, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 228213, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146652, 53),
      ))
    }

@delegate:ResourceContentHash(965_918_016)
public val Res.string.job_share_copied: StringResource by lazy {
      StringResource("string:job_share_copied", "job_share_copied", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161467, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 228283, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146706, 40),
      ))
    }

@delegate:ResourceContentHash(564_811_168)
public val Res.string.job_share_copy: StringResource by lazy {
      StringResource("string:job_share_copy", "job_share_copy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161512, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 228364, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146747, 34),
      ))
    }

@delegate:ResourceContentHash(-1_705_702_955)
public val Res.string.job_share_draft_hint: StringResource by lazy {
      StringResource("string:job_share_draft_hint", "job_share_draft_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161551, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 228439, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146782, 84),
      ))
    }

@delegate:ResourceContentHash(-59_603_693)
public val Res.string.job_share_hint: StringResource by lazy {
      StringResource("string:job_share_hint", "job_share_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161640, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 228600, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146867, 82),
      ))
    }

@delegate:ResourceContentHash(342_755_800)
public val Res.string.job_share_open: StringResource by lazy {
      StringResource("string:job_share_open", "job_share_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161735, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 228767, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146950, 42),
      ))
    }

@delegate:ResourceContentHash(37_510_096)
public val Res.string.job_share_qr: StringResource by lazy {
      StringResource("string:job_share_qr", "job_share_qr", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161778, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 228834, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146993, 52),
      ))
    }

@delegate:ResourceContentHash(-1_521_099_470)
public val Res.string.job_share_send: StringResource by lazy {
      StringResource("string:job_share_send", "job_share_send", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161823, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 228891, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147046, 30),
      ))
    }

@delegate:ResourceContentHash(-1_426_513_086)
public val Res.string.job_share_text: StringResource by lazy {
      StringResource("string:job_share_text", "job_share_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161862, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 228942, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147077, 58),
      ))
    }

@delegate:ResourceContentHash(125_028_681)
public val Res.string.job_share_title: StringResource by lazy {
      StringResource("string:job_share_title", "job_share_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161929, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 229025, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147136, 43),
      ))
    }

@delegate:ResourceContentHash(-1_646_035_147)
public val Res.string.join_invite_invalid: StringResource by lazy {
      StringResource("string:join_invite_invalid", "join_invite_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 161985, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 229101, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147180, 83),
      ))
    }

@delegate:ResourceContentHash(1_589_648_425)
public val Res.string.join_pending_hint: StringResource by lazy {
      StringResource("string:join_pending_hint", "join_pending_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 162073, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 229241, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147264, 89),
      ))
    }

@delegate:ResourceContentHash(1_714_728_314)
public val Res.string.join_team_error: StringResource by lazy {
      StringResource("string:join_team_error", "join_team_error", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 162183, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 229419, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147354, 47),
      ))
    }

@delegate:ResourceContentHash(543_084_408)
public val Res.string.join_team_go_to_dashboard: StringResource by lazy {
      StringResource("string:join_team_go_to_dashboard", "join_team_go_to_dashboard", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 162231, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 229491, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147402, 53),
      ))
    }

@delegate:ResourceContentHash(-1_065_974_207)
public val Res.string.join_team_invited: StringResource by lazy {
      StringResource("string:join_team_invited", "join_team_invited", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 162334, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 229654, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147501, 57),
      ))
    }

@delegate:ResourceContentHash(583_790_825)
public val Res.string.join_team_invited_by: StringResource by lazy {
      StringResource("string:join_team_invited_by", "join_team_invited_by", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 162293, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 229589, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147456, 44),
      ))
    }

@delegate:ResourceContentHash(-1_078_639_103)
public val Res.string.join_team_join: StringResource by lazy {
      StringResource("string:join_team_join", "join_team_join", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 162384, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 229728, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147559, 34),
      ))
    }

@delegate:ResourceContentHash(995_351_933)
public val Res.string.join_team_verifying: StringResource by lazy {
      StringResource("string:join_team_verifying", "join_team_verifying", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 162435, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 229807, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147594, 59),
      ))
    }

@delegate:ResourceContentHash(1_063_749_081)
public val Res.string.join_team_workplace: StringResource by lazy {
      StringResource("string:join_team_workplace", "join_team_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 162499, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 229899, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147654, 39),
      ))
    }

@delegate:ResourceContentHash(1_605_512_482)
public val Res.string.kiosk_back_soon: StringResource by lazy {
      StringResource("string:kiosk_back_soon", "kiosk_back_soon", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 162535, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 229943, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147694, 63),
      ))
    }

@delegate:ResourceContentHash(-1_742_933_570)
public val Res.string.kiosk_break_end: StringResource by lazy {
      StringResource("string:kiosk_break_end", "kiosk_break_end", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 162595, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 230039, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147758, 35),
      ))
    }

@delegate:ResourceContentHash(-668_493_280)
public val Res.string.kiosk_break_start: StringResource by lazy {
      StringResource("string:kiosk_break_start", "kiosk_break_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 162643, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 230107, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147794, 41),
      ))
    }

@delegate:ResourceContentHash(1_352_274_416)
public val Res.string.kiosk_checklist_hint_close: StringResource by lazy {
      StringResource("string:kiosk_checklist_hint_close", "kiosk_checklist_hint_close", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 162697, 150),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 230169, 222),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147836, 130),
      ))
    }

@delegate:ResourceContentHash(-770_214_004)
public val Res.string.kiosk_checklist_hint_open: StringResource by lazy {
      StringResource("string:kiosk_checklist_hint_open", "kiosk_checklist_hint_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 162848, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 230392, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147967, 105),
      ))
    }

@delegate:ResourceContentHash(-381_366_971)
public val Res.string.kiosk_checklist_needs_connection: StringResource by lazy {
      StringResource("string:kiosk_checklist_needs_connection", "kiosk_checklist_needs_connection", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 162958, 184),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 230542, 284),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148073, 160),
      ))
    }

@delegate:ResourceContentHash(-477_944_223)
public val Res.string.kiosk_checklist_offline: StringResource by lazy {
      StringResource("string:kiosk_checklist_offline", "kiosk_checklist_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 163143, 135),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 230827, 223),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148234, 123),
      ))
    }

@delegate:ResourceContentHash(824_264_295)
public val Res.string.kiosk_checklist_skip: StringResource by lazy {
      StringResource("string:kiosk_checklist_skip", "kiosk_checklist_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 163552, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 231464, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148587, 36),
      ))
    }

@delegate:ResourceContentHash(992_947_311)
public val Res.string.kiosk_checklist_skip_close: StringResource by lazy {
      StringResource("string:kiosk_checklist_skip_close", "kiosk_checklist_skip_close", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 163279, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 231051, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148358, 58),
      ))
    }

@delegate:ResourceContentHash(34_605_147)
public val Res.string.kiosk_checklist_skip_note: StringResource by lazy {
      StringResource("string:kiosk_checklist_skip_note", "kiosk_checklist_skip_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 163350, 201),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 231158, 305),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148417, 169),
      ))
    }

@delegate:ResourceContentHash(360_658_516)
public val Res.string.kiosk_checklist_title_close: StringResource by lazy {
      StringResource("string:kiosk_checklist_title_close", "kiosk_checklist_title_close", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 163589, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 231521, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148624, 71),
      ))
    }

@delegate:ResourceContentHash(1_453_959_453)
public val Res.string.kiosk_checklist_title_open: StringResource by lazy {
      StringResource("string:kiosk_checklist_title_open", "kiosk_checklist_title_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 163661, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 231617, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148696, 66),
      ))
    }

@delegate:ResourceContentHash(1_272_303_177)
public val Res.string.kiosk_clock_auto: StringResource by lazy {
      StringResource("string:kiosk_clock_auto", "kiosk_clock_auto", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 163732, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 231712, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148763, 44),
      ))
    }

@delegate:ResourceContentHash(-1_026_035_333)
public val Res.string.kiosk_clock_in: StringResource by lazy {
      StringResource("string:kiosk_clock_in", "kiosk_clock_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 163797, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 231805, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148808, 38),
      ))
    }

@delegate:ResourceContentHash(168_536_159)
public val Res.string.kiosk_clock_out: StringResource by lazy {
      StringResource("string:kiosk_clock_out", "kiosk_clock_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 163844, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 231860, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148847, 35),
      ))
    }

@delegate:ResourceContentHash(-1_364_279_018)
public val Res.string.kiosk_code_generate: StringResource by lazy {
      StringResource("string:kiosk_code_generate", "kiosk_code_generate", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 163892, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 231924, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148883, 43),
      ))
    }

@delegate:ResourceContentHash(1_475_011_368)
public val Res.string.kiosk_code_text: StringResource by lazy {
      StringResource("string:kiosk_code_text", "kiosk_code_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 163936, 207),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 231984, 319),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148927, 175),
      ))
    }

@delegate:ResourceContentHash(1_110_953_030)
public val Res.string.kiosk_confirm_break_end: StringResource by lazy {
      StringResource("string:kiosk_confirm_break_end", "kiosk_confirm_break_end", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 164144, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 232304, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149103, 87),
      ))
    }

@delegate:ResourceContentHash(-969_679_281)
public val Res.string.kiosk_confirm_break_start: StringResource by lazy {
      StringResource("string:kiosk_confirm_break_start", "kiosk_confirm_break_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 164244, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 232444, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149191, 89),
      ))
    }

@delegate:ResourceContentHash(268_547_574)
public val Res.string.kiosk_confirm_in: StringResource by lazy {
      StringResource("string:kiosk_confirm_in", "kiosk_confirm_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 164330, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 232590, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149281, 72),
      ))
    }

@delegate:ResourceContentHash(832_807_320)
public val Res.string.kiosk_confirm_out: StringResource by lazy {
      StringResource("string:kiosk_confirm_out", "kiosk_confirm_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 164411, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 232687, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149354, 77),
      ))
    }

@delegate:ResourceContentHash(1_340_575_384)
public val Res.string.kiosk_confirm_queued: StringResource by lazy {
      StringResource("string:kiosk_confirm_queued", "kiosk_confirm_queued", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 164497, 164),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 232793, 268),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149432, 136),
      ))
    }

@delegate:ResourceContentHash(977_494_619)
public val Res.string.kiosk_delete_digit: StringResource by lazy {
      StringResource("string:kiosk_delete_digit", "kiosk_delete_digit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 164662, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 233062, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149569, 42),
      ))
    }

@delegate:ResourceContentHash(1_218_370_379)
public val Res.string.kiosk_device_last_seen: StringResource by lazy {
      StringResource("string:kiosk_device_last_seen", "kiosk_device_last_seen", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 164705, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 233125, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149612, 50),
      ))
    }

@delegate:ResourceContentHash(1_988_936_871)
public val Res.string.kiosk_device_revoked: StringResource by lazy {
      StringResource("string:kiosk_device_revoked", "kiosk_device_revoked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 164764, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 233216, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149663, 40),
      ))
    }

@delegate:ResourceContentHash(-740_556_822)
public val Res.string.kiosk_enter_pin: StringResource by lazy {
      StringResource("string:kiosk_enter_pin", "kiosk_enter_pin", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 164809, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 233273, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149704, 43),
      ))
    }

@delegate:ResourceContentHash(-724_779_853)
public val Res.string.kiosk_error_code: StringResource by lazy {
      StringResource("string:kiosk_error_code", "kiosk_error_code", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 164853, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 233329, 176),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149748, 100),
      ))
    }

@delegate:ResourceContentHash(868_356_506)
public val Res.string.kiosk_error_device_time: StringResource by lazy {
      StringResource("string:kiosk_error_device_time", "kiosk_error_device_time", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 164946, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 233506, 187),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149849, 103),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString19Resources(map: MutableMap<String, StringResource>) {
  map.put("job_cv_max_size", Res.string.job_cv_max_size)
  map.put("job_cv_none", Res.string.job_cv_none)
  map.put("job_cv_optional", Res.string.job_cv_optional)
  map.put("job_cv_required", Res.string.job_cv_required)
  map.put("job_cv_types", Res.string.job_cv_types)
  map.put("job_delete", Res.string.job_delete)
  map.put("job_delete_confirm_text", Res.string.job_delete_confirm_text)
  map.put("job_delete_confirm_title", Res.string.job_delete_confirm_title)
  map.put("job_deleted", Res.string.job_deleted)
  map.put("job_editor_new_title", Res.string.job_editor_new_title)
  map.put("job_editor_title", Res.string.job_editor_title)
  map.put("job_error_contact", Res.string.job_error_contact)
  map.put("job_error_cv_types", Res.string.job_error_cv_types)
  map.put("job_error_employer", Res.string.job_error_employer)
  map.put("job_error_pay", Res.string.job_error_pay)
  map.put("job_error_pay_range", Res.string.job_error_pay_range)
  map.put("job_error_title", Res.string.job_error_title)
  map.put("job_error_too_long", Res.string.job_error_too_long)
  map.put("job_field_city", Res.string.job_field_city)
  map.put("job_field_closes", Res.string.job_field_closes)
  map.put("job_field_contact", Res.string.job_field_contact)
  map.put("job_field_contact_hint", Res.string.job_field_contact_hint)
  map.put("job_field_contract", Res.string.job_field_contract)
  map.put("job_field_description", Res.string.job_field_description)
  map.put("job_field_employer", Res.string.job_field_employer)
  map.put("job_field_employer_hint", Res.string.job_field_employer_hint)
  map.put("job_field_hours", Res.string.job_field_hours)
  map.put("job_field_hours_hint", Res.string.job_field_hours_hint)
  map.put("job_field_language", Res.string.job_field_language)
  map.put("job_field_pay_max", Res.string.job_field_pay_max)
  map.put("job_field_pay_min", Res.string.job_field_pay_min)
  map.put("job_field_role", Res.string.job_field_role)
  map.put("job_field_title", Res.string.job_field_title)
  map.put("job_field_title_hint", Res.string.job_field_title_hint)
  map.put("job_lang_en", Res.string.job_lang_en)
  map.put("job_lang_pl", Res.string.job_lang_pl)
  map.put("job_lang_uk", Res.string.job_lang_uk)
  map.put("job_pay_hint", Res.string.job_pay_hint)
  map.put("job_pay_per_hour", Res.string.job_pay_per_hour)
  map.put("job_pay_per_month", Res.string.job_pay_per_month)
  map.put("job_publish", Res.string.job_publish)
  map.put("job_published", Res.string.job_published)
  map.put("job_recruiters_empty", Res.string.job_recruiters_empty)
  map.put("job_recruiters_hint", Res.string.job_recruiters_hint)
  map.put("job_rejection_body", Res.string.job_rejection_body)
  map.put("job_rejection_enabled", Res.string.job_rejection_enabled)
  map.put("job_rejection_hint", Res.string.job_rejection_hint)
  map.put("job_rejection_subject", Res.string.job_rejection_subject)
  map.put("job_reopen", Res.string.job_reopen)
  map.put("job_save_draft", Res.string.job_save_draft)
  map.put("job_saved", Res.string.job_saved)
  map.put("job_section_cv", Res.string.job_section_cv)
  map.put("job_section_recruiters", Res.string.job_section_recruiters)
  map.put("job_section_rejection", Res.string.job_section_rejection)
  map.put("job_share_copied", Res.string.job_share_copied)
  map.put("job_share_copy", Res.string.job_share_copy)
  map.put("job_share_draft_hint", Res.string.job_share_draft_hint)
  map.put("job_share_hint", Res.string.job_share_hint)
  map.put("job_share_open", Res.string.job_share_open)
  map.put("job_share_qr", Res.string.job_share_qr)
  map.put("job_share_send", Res.string.job_share_send)
  map.put("job_share_text", Res.string.job_share_text)
  map.put("job_share_title", Res.string.job_share_title)
  map.put("join_invite_invalid", Res.string.join_invite_invalid)
  map.put("join_pending_hint", Res.string.join_pending_hint)
  map.put("join_team_error", Res.string.join_team_error)
  map.put("join_team_go_to_dashboard", Res.string.join_team_go_to_dashboard)
  map.put("join_team_invited", Res.string.join_team_invited)
  map.put("join_team_invited_by", Res.string.join_team_invited_by)
  map.put("join_team_join", Res.string.join_team_join)
  map.put("join_team_verifying", Res.string.join_team_verifying)
  map.put("join_team_workplace", Res.string.join_team_workplace)
  map.put("kiosk_back_soon", Res.string.kiosk_back_soon)
  map.put("kiosk_break_end", Res.string.kiosk_break_end)
  map.put("kiosk_break_start", Res.string.kiosk_break_start)
  map.put("kiosk_checklist_hint_close", Res.string.kiosk_checklist_hint_close)
  map.put("kiosk_checklist_hint_open", Res.string.kiosk_checklist_hint_open)
  map.put("kiosk_checklist_needs_connection", Res.string.kiosk_checklist_needs_connection)
  map.put("kiosk_checklist_offline", Res.string.kiosk_checklist_offline)
  map.put("kiosk_checklist_skip", Res.string.kiosk_checklist_skip)
  map.put("kiosk_checklist_skip_close", Res.string.kiosk_checklist_skip_close)
  map.put("kiosk_checklist_skip_note", Res.string.kiosk_checklist_skip_note)
  map.put("kiosk_checklist_title_close", Res.string.kiosk_checklist_title_close)
  map.put("kiosk_checklist_title_open", Res.string.kiosk_checklist_title_open)
  map.put("kiosk_clock_auto", Res.string.kiosk_clock_auto)
  map.put("kiosk_clock_in", Res.string.kiosk_clock_in)
  map.put("kiosk_clock_out", Res.string.kiosk_clock_out)
  map.put("kiosk_code_generate", Res.string.kiosk_code_generate)
  map.put("kiosk_code_text", Res.string.kiosk_code_text)
  map.put("kiosk_confirm_break_end", Res.string.kiosk_confirm_break_end)
  map.put("kiosk_confirm_break_start", Res.string.kiosk_confirm_break_start)
  map.put("kiosk_confirm_in", Res.string.kiosk_confirm_in)
  map.put("kiosk_confirm_out", Res.string.kiosk_confirm_out)
  map.put("kiosk_confirm_queued", Res.string.kiosk_confirm_queued)
  map.put("kiosk_delete_digit", Res.string.kiosk_delete_digit)
  map.put("kiosk_device_last_seen", Res.string.kiosk_device_last_seen)
  map.put("kiosk_device_revoked", Res.string.kiosk_device_revoked)
  map.put("kiosk_enter_pin", Res.string.kiosk_enter_pin)
  map.put("kiosk_error_code", Res.string.kiosk_error_code)
  map.put("kiosk_error_device_time", Res.string.kiosk_error_device_time)
}
